import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { UserPlus, LogIn } from "lucide-react";

const AuthLayout = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/register/login");
  };

  const handleRegisterClick = () => {
    navigate("/register");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold text-right">
            التوثيق
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            onClick={handleLoginClick}
            className="w-full text-lg h-12 bg-primary hover:bg-primary/90 flex items-center justify-center gap-2"
          >
            <LogIn className="w-5 h-5" />
            <span>تسجيل الدخول</span>
          </Button>

          <Button
            onClick={handleRegisterClick}
            variant="outline"
            className="w-full text-lg h-12 flex items-center justify-center gap-2"
          >
            <UserPlus className="w-5 h-5" />
            <span>إنشاء حساب</span>
          </Button>
        </CardContent>
        <Outlet />
      </Card>
    </div>
  );
};

export default AuthLayout;
